<template>
  <component :is="tag" :contenteditable="contenteditable" @input="update" @blur="onBlur" @paste="onPaste" @keypress="onKeypress" ref="element"> </component>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';

const replaceAll = (str: string, search: string, replacement: string) => str.split(search).join(replacement);

interface ContentEditableProps {
  tag: string;
  contenteditable: boolean;
  modelValue: string;
  noHtml?: boolean;
  noNl?: boolean;
}

const props = defineProps<ContentEditableProps>();

const emit = defineEmits(['returned', 'update:modelValue', 'blur']);

const element = ref<HTMLElement | null>();

const currentContent = () => (props.noHtml ? element.value!.innerText : element.value!.innerHTML);
const updateContent = (newcontent: string) => {
  if (props.noHtml) {
    element.value!.innerText = newcontent;
    return;
  }

  element.value!.innerHTML = newcontent;
};

const onBlur = () => {
  update();
  emit('blur');
};

const update = () => {
  emit('update:modelValue', currentContent());
};

const onPaste = (event: any) => {
  event.preventDefault();
  let text = (event.originalEvent || event).clipboardData.getData('text/plain');

  if (props.noNl) {
    text = replaceAll(text, '\r\n', ' ');
    text = replaceAll(text, '\n', ' ');
    text = replaceAll(text, '\r', ' ');
  }

  element.value!.innerText = text;
};

const onKeypress = (event: any) => {
  if (event.key == 'Enter' && props.noNl) {
    event.preventDefault();
    emit('returned', currentContent());
  }
};

onMounted(() => {
  updateContent(props.modelValue ?? '');
});

watch(
  () => props.modelValue,
  newval => {
    if (newval != currentContent()) {
      updateContent(newval ?? '');
    }
  }
);

watch(
  () => props.noHtml,
  () => updateContent(props.modelValue ?? '')
);
watch(
  () => props.tag,
  () => updateContent(props.modelValue ?? ''),
  { flush: 'post' }
);
</script>
